import { useSnackbar } from 'notistack';
import ReactDOM from 'react-dom';
import { useTranslation } from 'react-i18next';

import { useLoggedInUserRoles } from '~/components/Auth';
import { useEmployeeItemInfo } from '~/components/GenericList/EmployeeItemInfo/useEmployeeItemInfo';
import { useAuthentication } from '~/data/user/useAuthentication';
import {
  DispatchReduxFetch,
  useInitializeCommonReduxData,
} from '~/hooks/initializeData';
import { Providers } from '~/Providers';
import {
  OrgUnitPopup,
  OrgUnitPopupProps,
} from '~/scenes/PortalViews/Views/PortalAltMgr/components/OrgUnitPopup/component';

import { LibraryComponentProviders } from '../components/LibraryComponentProviders';

export const OrganizationUnitPopup = (props: OrgUnitPopupProps) => {
  const { userDetails, isAuthenticated } = useAuthentication();
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const loggedInUserRoles = useLoggedInUserRoles();
  const { getEmployeeItemInfoByIds } = useEmployeeItemInfo();

  const {
    requiredStatus: { isReady },
  } = useInitializeCommonReduxData({
    required: [DispatchReduxFetch.AllEmployees, DispatchReduxFetch.AllOrgUnits],
  });

  if (
    !isReady ||
    !isAuthenticated ||
    !userDetails ||
    !t ||
    !enqueueSnackbar ||
    !loggedInUserRoles ||
    !getEmployeeItemInfoByIds
  ) {
    return null;
  }

  return (
    <LibraryComponentProviders>
      <OrgUnitPopup {...props} />
    </LibraryComponentProviders>
  );
};

export const renderOrganizationUnitPopup = (
  containerId: string,
  props: OrgUnitPopupProps,
) => {
  ReactDOM.render(
    <Providers>
      <OrganizationUnitPopup {...props} />
    </Providers>,
    document.getElementById(containerId),
  );
};
